import React from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { MicrophoneActivity, useToggleLocalMute } from 'amazon-chime-sdk-component-library-react'
import Fab from '@mui/material/Fab'
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined'
import MicOffOutlinedIcon from '@mui/icons-material/MicOffOutlined'
import ControlBarItem from './ControlBarItem'

type AudioInputControlProps = {
  attendeeId?: string
}

export default function AudioInputControl(props: AudioInputControlProps) {
  useLingui()
  const { muted, toggleMute } = useToggleLocalMute()
  const label = muted ? t`Unmute microphone` : t`Mute microphone`

  if (!props.attendeeId)
    return (
      <ControlBarItem>
        <Fab color="primary" onClick={toggleMute} size="small" aria-label={label}>
          {muted ? <MicOffOutlinedIcon /> : <MicNoneOutlinedIcon />}
        </Fab>
      </ControlBarItem>
    )

  return (
    <ControlBarItem>
      <Fab color="primary" onClick={toggleMute} size="small" aria-label={label}>
        <MicrophoneActivity attendeeId={props.attendeeId} />
      </Fab>
    </ControlBarItem>
  )
}
